import React, { Suspense } from 'react';
import {Route, Routes} from 'react-router-dom';
import { Spin } from 'antd';
import ToolVisitTracker from "./ToolVisitTracker";
import PageViewTracker from './PageViewTracker';
import { IMG_CLOUD_ROUTE_DEFINITIONS } from './definitions';

// The prerender script waits while this marker is present, so keep the attribute name in sync.
export const RouteLoading: React.FC = () => (
  <div
    data-img-cloud-route-loading=""
    style={{ display: 'flex', justifyContent: 'center', padding: '96px 0' }}
  >
    <Spin />
  </div>
);

const AppRoutes: React.FC = () => {
  return (
    <>
      <ToolVisitTracker />
      <PageViewTracker />
      <Suspense fallback={<RouteLoading />}>
        <Routes>
          {IMG_CLOUD_ROUTE_DEFINITIONS.map((definition) => (
            <Route
              key={definition.path}
              path={definition.path}
              element={definition.element}
            />
          ))}
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRoutes;
